import React, { FC, ReactNode } from 'react';
import { VisuallyHidden } from '@indeed/ifl-components';

interface MainContentProps {
    children: ReactNode;
}

const MainContent: FC<MainContentProps> = ({ children }) => {
    // # a11y; Start of the main content of the web site ;jobseekers
    const startOfMainContent = 'Start of main content'; //  TODO: Wrap for translation

    return (
        <div
            id="messaging-main-content"
            tabIndex={-1}
            style={{
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
            }}
        >
            <div>
                <VisuallyHidden>{startOfMainContent}</VisuallyHidden>
            </div>
            {children}
        </div>
    );
};

export default MainContent;
